import React from 'react';
import { JsonTableConverter } from '../components/json-table-converter/JsonTableConverter';

export const JsonTableConverterPage: React.FC = () => {
  return (
    <div className="page-container">
      <JsonTableConverter />
    </div>
  );
};